import React from "react";

const BeerSectionItem = ({isOpen, item, section}) => {

    return (
        <div key={item.id} className={"menu-item beer-item " + (isOpen.includes(section.id) ? "_collapsed" : "")}>
            <div className="item-name-icon --beer">
                {item.imageUrl && <img src={item.imageUrl} alt={item.name} className="beer-image" />}
                <div>
                    <h4>{item.name}</h4>
                    <p>{(item.brewery ? (item.brewery + ' | ') : "") + (item.beerStyle ? (item.beerStyle + ' | ') : "") + (item.abv ? (item.abv) : "")}</p>
                </div>
            </div>
            <div className='beer-content'>
                <div>
                    <p className='beer-paragraph'>{item.description}</p>
                </div>
                <div className="prices">
                    {item.prices.map((priceObj, index) => (
                        <p className="beer-price" key={index}><i>{priceObj.size + '  '}</i>{priceObj.price}</p>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default BeerSectionItem;